<template>
  <div class="page-container">
    <div class="page_title">
      <div class="page_title_desc">查询运单实时位置demo</div>
    </div>
    <el-divider></el-divider>
      <el-form :model="searchForm" inline size="small">
        <el-form-item label="">
          <el-input
            v-model="searchForm.waybillNo"
            clearable
            placeholder="运单号"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">搜索</el-button>
        </el-form-item>
      </el-form>
    <div id="map_container" class="map_container"></div>
  </div>
</template>

<script>
import BaiduMap from "@/utils/baidu-map.js";
  const redMarker = new BMap.Symbol(BMap_Symbol_SHAPE_POINT, {
    scale: 1,//图标缩放大小
    fillColor: "#d81e06",//填充颜色
    fillOpacity: 1,//填充透明度
    strokeOpacity:1, //线透明度
    strokeColor:'#d81e06'
  })
const yellowMarker = new BMap.Symbol(BMap_Symbol_SHAPE_POINT, {
    scale: 1,//图标缩放大小
    fillColor: "#f4ea2a",//填充颜色
    fillOpacity: 1,//填充透明度
    strokeOpacity:1, //线透明度,
    strokeColor:"#f4ea2a"
  })
const blueMarker = new BMap.Symbol(BMap_Symbol_SHAPE_POINT, {
    scale: 1,//图标缩放大小
    fillColor: "#1296db",//填充颜色
    fillOpacity: 1,//填充透明度
    strokeOpacity:1, //线透明度
    strokeColor:"#1296db"
  })
const deepblueMarker = new BMap.Symbol(BMap_Symbol_SHAPE_POINT, {
    scale: 1,//图标缩放大小
    fillColor: "#13227a",//填充颜色
    fillOpacity: 1,//填充透明度
    strokeOpacity:1, //线透明度
    strokeColor:"#13227a"
  })
const arr = [redMarker,blueMarker,deepblueMarker]
let map = null;
export default {
  data() {
    return {
      searchForm: {},
    };
  },
  mounted() {
    this.mapInit()
  },
  methods: {
    async mapInit(){
      await BaiduMap.initVersion2();
      map = new BMap.Map("map_container", {
        enableMapClick: false,
      });
      map.centerAndZoom(new BMap.Point(116.404, 39.915),13);
      map.enableScrollWheelZoom();
    },
    async handleSearch(){
      
      let {waybillNo} = this.searchForm
      if(!waybillNo) return
      let res = await this.$api.DriverModel.mGetDriverLoc({
        driverNos:waybillNo
      })
      this.curPos = [...res.data]
      map.clearOverlays();
      res.data.length && res.data.forEach((item,index) => {
        let marker  =  new BMap.Marker(new BMap.Point(item.lng,item.lat),{
          icon:arr[index]
        })
        let infoWindow =new BMap.InfoWindow(`司机工号：${item.driverNo}`)
        marker.addEventListener('click',()=>{
          map.openInfoWindow(infoWindow, new BMap.Point(item.lng,item.lat))
        })
        map.addOverlay(marker)
      })
      
      this.timer && clearInterval(this.timer)
      this.timer = setInterval(() => {
        this.handleSearch()
      }, 3000);
    }
  },
};
</script>

<style lang="scss" scoped>
.page-container{
  height: 100%;
}
.map_container{
  width: 100%;
  height: 80%;
}
</style>